import { useScrollToFocus } from '@capturi/react-utils'
import { Flex, HStack, SlideFade, Text } from '@chakra-ui/react'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { MagicBox, MagicBoxHeader } from 'copilot/components/MagicBox'
import { SummaryMarkdown } from 'copilot/components/SummaryMarkdown'
import type { FC, RefObject } from 'react'

import { useVoiceBotHandover } from './useVoiceBotHandover'

type Props = {
  copilotToken: string
  sessionUid: string
  showContent: boolean
  containerRef?: RefObject<HTMLElement | null>
}

export const VoiceBotHandover: FC<Props> = ({
  copilotToken,
  sessionUid,
  showContent,
  containerRef,
}) => {
  const { data } = useVoiceBotHandover(copilotToken, sessionUid)
  const scrollToFocus = useScrollToFocus(containerRef)

  if (data == null) return null

  return (
    <SlideFade in={showContent}>
      <Flex
        alignItems="center"
        flexDirection="column"
        mt={8}
        ref={scrollToFocus}
      >
        <MagicBox
          bg="productgradients.virtualAgents"
          width="clamp(240px, 464px, 100%)"
          backdropFilter="blur(64px)"
        >
          <MagicBoxHeader
            bg="gray.100"
            flexDir="row"
            alignItems="center"
            textColor="textMuted"
            p={4}
          >
            <Text fontWeight="semibold">
              <Trans>Virtual Agent handover</Trans>
            </Text>
          </MagicBoxHeader>
          <HStack alignItems="flex-start" p={3}>
            <SummaryMarkdown>
              {data.summary || t`No details available`}
            </SummaryMarkdown>
          </HStack>
        </MagicBox>
      </Flex>
    </SlideFade>
  )
}
